import BackButton from 'Components/BackButton'
import Breadcrumbs from 'Components/Breadcrumbs'
import PageTitle from 'Components/PageTitle'
import { TariffForm } from 'Services/ProductManagement/Features/Tariff/Components/TariffForm'
import { usePreviousLocation } from 'Util/Context/previousLocationContext'
import { PRODUCT_MANAGEMENT_ROOT_URL } from 'Util/constants'
import { Box, Grid } from '@mui/material'
import { t } from 'ttag'

export default function TariffCreatePage() {
  const baseUrl = `${PRODUCT_MANAGEMENT_ROOT_URL}/tariffs`
  const previousLocation = usePreviousLocation(baseUrl)

  const breadcrumbs = [
    {
      title: t`Home`,
      link: PRODUCT_MANAGEMENT_ROOT_URL
    },
    {
      title: t`Tariffs`,
      link: baseUrl
    },
    {
      title: t`Create new tariff`
    }
  ]

  return (
    <Box sx={{ width: '100%' }}>
      <Grid container spacing={2}>
        <Grid size={12}>
          <Breadcrumbs items={breadcrumbs} />
          <BackButton label={t`Back`} link={previousLocation} />
          <PageTitle>{t`Create new tariff`}</PageTitle>
        </Grid>
      </Grid>
      <TariffForm successBaseUrl={previousLocation} />
    </Box>
  )
}
